const TOOL_URLS = {
  chatgpt: { label: "ChatGPT", url: "https://chatgpt.com/", q: "q" },
  claude: { label: "Claude", url: "https://claude.ai/new", q: "q" },
  gemini: { label: "Gemini", url: "https://gemini.google.com/app" },
  grok: { label: "Grok", url: "https://grok.com/", q: "q" },
  perplexity: { label: "Perplexity", url: "https://www.perplexity.ai/search", q: "q" },
  midjourney: { label: "Midjourney", url: "https://www.midjourney.com/imagine" },
  dalle: { label: "ChatGPT", url: "https://chatgpt.com/", q: "q" },
  "stable-diffusion": { label: "Stable Diffusion", url: "https://stability.ai/" },
  sora: { label: "Sora", url: "https://sora.chatgpt.com/" },
  universal: { label: "ChatGPT", url: "https://chatgpt.com/", q: "q" },
};

export const openTargetFor = (tool) => TOOL_URLS[tool] || TOOL_URLS.universal;

export async function openInTool(tool, text) {
  const t = openTargetFor(tool);
  try { await navigator.clipboard.writeText(text); } catch (_) {}
  const url = t.q && text.length < 6000 ? `${t.url}?${t.q}=${encodeURIComponent(text)}` : t.url;
  window.open(url, "_blank", "noopener,noreferrer");
  return t;
}
